import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from "react";
import { createSingletonComponent, useSafeContext, } from "@aviv-unified-frontend/internal";
import { IS_DEV_LIKE_ENVIRONMENT } from "../../constants/environment";
import { GLOBAL_KEY } from "./constants";
const INTERNAL_GLOBAL_KEY = Symbol(GLOBAL_KEY);
const GlobalStoreContext = createContext(null);
export const createGlobalStoreContext = ({ initialApplication, headerFooterConfig, applicationId, errors, }) => {
    return {
        [INTERNAL_GLOBAL_KEY]: {
            initialApplication,
            headerFooterConfig,
            applicationId,
            errors,
        },
    };
};
const extractErrors = (errors) => {
    if (!IS_DEV_LIKE_ENVIRONMENT)
        return undefined;
    if (typeof errors !== "object")
        return undefined;
    if (Object.keys(errors).length > 0)
        return errors;
    return undefined;
};
export const GlobalStoreProvider = createSingletonComponent("GlobalStoreProvider", ({ children, context }) => {
    const { headerFooterConfig, initialApplication, applicationId: initialApplicationId, errors, } = context[INTERNAL_GLOBAL_KEY];
    const [applicationId, setApplicationId] = useState(initialApplicationId);
    const value = useMemo(() => {
        return {
            applicationId,
            headerFooterConfig,
            initialApplication,
            setApplicationId,
            errors: extractErrors(errors),
        };
    }, [
        headerFooterConfig,
        initialApplication,
        applicationId,
        setApplicationId,
        errors,
    ]);
    return (_jsx(GlobalStoreContext.Provider, { value: value, children: children }));
});
export const useGlobalStore = () => useSafeContext({
    package: "@aviv-unified-frontend/branded-shell",
    module: "global",
}, GlobalStoreContext);
